import { useFormContext } from '@/lib/form-contexts'
import PageAnnouncementBarLinkToggle from './PageAnnouncementBarLinkToggle'

const PREFIX = 'pages./contact-us.blocks.main.0'
const contactUs = (str) => `${PREFIX}.${str}`

const ContactUsPageForm = () => {
  const form = useFormContext()

  return (
    <div className="mb-4 flex flex-col gap-y-6">
      <PageAnnouncementBarLinkToggle pageKey="contactUs" />

      <form.AppField name={contactUs('props.title')}>
        {(field) => (
          <field.TextInput
            label="Page Title"
            placeholder="Contact Us"
            disabled={field.state.disabled}
          />
        )}
      </form.AppField>

      <form.AppField name={contactUs('props.description')}>
        {(field) => (
          <field.TextareaInput
            label="Page Description"
            placeholder="Explain how customers should use this form."
            rows={3}
            disabled={field.state.disabled}
          />
        )}
      </form.AppField>
    </div>
  )
}

export default ContactUsPageForm
